(() => {
  document.querySelectorAll("[data-product-detail]").forEach((root) => {
    const form = root.querySelector("[data-product-purchase]");
    const variantsNode = root.querySelector("[data-product-variants]");
    if (!form || !variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const idInput = form.querySelector("[data-variant-id]");
    const add = form.querySelector("[data-product-add]");
    const status = form.querySelector("[data-product-status]");
    const retry = form.querySelector("[data-product-retry]");
    const cartCheck = form.querySelector("[data-product-cart-check]");
    const optionGroups = [...form.querySelectorAll("[data-option-index]")];
    optionGroups.forEach(group => {
      const buttons = [...group.querySelectorAll('[data-option-value]')];
      const ids = window.SeifeThemeVisuals?.mapThemes(group.dataset.optionName, buttons.map(button => button.dataset.optionValue));
      if (!ids) return;
      group.classList.add('product-option--themes');
      // Existing native buttons retain their values, selection and click hooks.
      group.querySelector('[role=radiogroup]')?.setAttribute('role', 'group');
      buttons.forEach((button, index) => {
        if (ids[index]) window.SeifeThemeVisuals.decorateVariant(button, ids[index]);
      });
    });
    let selected = variants.find((variant) => String(variant.id) === idInput.value) || variants[0];
    let controller;
    const gallery = root.querySelector("[data-product-gallery]");
    const wishlist = root.querySelector(".product-detail__wishlist");
    if (gallery && wishlist) gallery.appendChild(wishlist);
    const dialog = root.querySelector("[data-product-zoom-dialog]");
    const imageSlides = [...(gallery?.querySelectorAll("[data-gallery-image]") || [])];
    let zoomTrigger;
    const syncZoom = (slide) => {
      if (!dialog?.open || !slide?.hasAttribute("data-gallery-image")) return;
      const source = slide.querySelector("[data-product-zoom] img");
      const image = dialog.querySelector("[data-product-zoom-image]");
      image.src = source.src;
      image.alt = source.alt;
    };

    const showMedia = (id) => {
      if (!gallery || !id) return;
      const slide = [...gallery.querySelectorAll("[data-media-id]")].find((node) => node.dataset.mediaId === String(id));
      if (!slide) return;
      gallery.querySelectorAll("[data-media-id]").forEach((slide) => {
        const active = slide.dataset.mediaId === String(id);
        slide.hidden = !active;
        slide.classList.toggle("is-active", active);
      });
      gallery.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
        const active = thumb.dataset.galleryThumb === String(id);
        thumb.setAttribute("aria-selected", String(active));
        thumb.tabIndex = active ? 0 : -1;
      });
      if (dialog?.open) {
        if (slide.hasAttribute("data-gallery-image")) syncZoom(slide);
        else dialog.close();
      }
    };
    const selectedOptions = () => optionGroups.map((group) => group.querySelector("[aria-pressed=true]")?.dataset.optionValue);
    const syncOptionAvailability = () => {
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll("[data-option-value]").forEach((button) => {
          const candidate = selectedOptions();
          candidate[groupIndex] = button.dataset.optionValue;
          const possible = variants.some((variant) => variant.available && variant.options.every((value, index) => value === candidate[index]));
          button.classList.toggle("is-unavailable", !possible);
          button.setAttribute("aria-label", possible ? button.dataset.optionValue : `${button.dataset.optionValue} — ${root.dataset.unavailableLabel}`);
        });
      });
    };
    const syncPlans = () => {
      const select = form.querySelector("[data-selling-plan]");
      const subscription = form.querySelector('[name=purchase_type][value=subscription]');
      if (!select || !subscription) return;
      select.replaceChildren(...selected.plans.map((plan) => {
        const option = document.createElement("option");
        option.value = plan.id;
        option.textContent = `${plan.name} — ${plan.price}`;
        return option;
      }));
      subscription.disabled = !selected.plans.length;
      if (!selected.plans.length) form.querySelector('[name=purchase_type][value=once]').checked = true;
      select.disabled = !subscription.checked || !selected.plans.length;
      const activePlan = selected.plans.find((plan) => String(plan.id) === select.value) || selected.plans[0];
      root.querySelector("[data-product-price]").lastChild.textContent = subscription.checked && activePlan ? activePlan.price : selected.price;
      const compare = root.querySelector("[data-product-compare]");
      compare.hidden = subscription.checked || !selected.compareAt;
    };
    const syncVariant = (push = true) => {
      const options = selectedOptions();
      // Default-only products have no option controls. Preserve the actual
      // Liquid-selected identity rather than comparing ["Default Title"] to [].
      selected = optionGroups.length
        ? variants.find((variant) => variant.options.every((value, index) => value === options[index]))
        : variants.find((variant) => String(variant.id) === idInput.value) || variants[0];
      if (!selected) {
        idInput.value = "";
        add.disabled = true;
        add.textContent = root.dataset.unavailableLabel;
        status.textContent = root.dataset.validationLabel;
        status.classList.add("error");
        return;
      }
      idInput.value = selected.id;
      add.disabled = !selected.available;
      add.textContent = selected.available ? root.dataset.addLabel : root.dataset.soldLabel;
      root.querySelector("[data-product-price]").lastChild.textContent = selected.price;
      const compare = root.querySelector("[data-product-compare]");
      compare.hidden = !selected.compareAt;
      if (selected.compareAt) compare.lastChild.textContent = selected.compareAt;
      const unit = root.querySelector("[data-product-unit]");
      unit.hidden = !selected.unit;
      unit.textContent = selected.unit || "";
      status.textContent = "";
      status.classList.remove("error");
      showMedia(selected.mediaId);
      syncPlans();
      syncOptionAvailability();
      if (push) history.replaceState({}, "", selected.url);
    };

    optionGroups.forEach((group) => group.addEventListener("click", (event) => {
      const button = event.target.closest("[data-option-value]");
      if (!button) return;
      group.querySelectorAll("[data-option-value]").forEach((value) => {
        const active = value === button;
        value.classList.toggle("is-selected", active);
        value.setAttribute("aria-pressed", String(active));
      });
      syncVariant();
    }));
    form.querySelectorAll("[name=purchase_type]").forEach((radio) => radio.addEventListener("change", syncPlans));
    form.querySelector("[data-selling-plan]")?.addEventListener("change", syncPlans);
    form.querySelectorAll("[data-quantity-change]").forEach((button) => button.addEventListener("click", () => {
      const input = form.querySelector("[name=quantity]");
      input.value = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange));
    }));

    const fetchCart = async () => {
      const cartController = new AbortController();
      const cartTimer = setTimeout(() => cartController.abort(), 5000);
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
          headers: { Accept: "application/json" }, signal: cartController.signal,
        });
        if (!response.ok) throw new Error("cart");
        return await response.json();
      } finally {
        clearTimeout(cartTimer);
      }
    };
    const matchingQuantity = (cart, variantId, planId) => cart.items
      .filter((item) => String(item.variant_id) === String(variantId)
        && String(item.selling_plan_allocation?.selling_plan?.id || "") === String(planId || ""))
      .reduce((sum, item) => sum + item.quantity, 0);
    const updateCartCount = (cart) => {
      document.querySelectorAll("[data-cart-count]").forEach((node) => {
        node.textContent = cart.item_count;
        node.hidden = false;
      });
    };
    const submit = async () => {
      if (!selected?.available || form.dataset.submitting === "true") return;
      const requestedQuantity = Number(form.querySelector("[name=quantity]").value);
      if (!Number.isSafeInteger(requestedQuantity) || requestedQuantity < 1) {
        status.textContent = root.dataset.validationLabel;
        status.classList.add("error");
        form.querySelector("[name=quantity]").focus();
        return;
      }
      form.dataset.submitting = "true";
      add.disabled = true;
      add.textContent = root.dataset.addingLabel;
      retry.hidden = true;
      cartCheck.hidden = true;
      status.textContent = root.dataset.addingLabel;
      status.classList.remove("error");
      const planId = form.querySelector("[data-selling-plan]:not(:disabled)")?.value || "";
      const requestedVariantId = selected.id;
      const payload = new FormData(form);
      let beforeCart;
      try { beforeCart = await fetchCart(); } catch (error) { beforeCart = null; }
      controller?.abort();
      controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000);
      let uncertain = false;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
          method: "POST", headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: payload, signal: controller.signal,
        });
        if (!response.ok) {
          if (response.status === 422) throw new Error("changed");
          throw new Error("rejected");
        }
        status.textContent = root.dataset.addedLabel;
        try {
          const addedItem = await response.json();
          const cart = await fetchCart();
          updateCartCount(cart);
          document.dispatchEvent(new CustomEvent("seife:ordinary-added", { detail: { key: addedItem.key, variantId: requestedVariantId, cart } }));
        } catch (error) { /* The confirmed add remains successful; uncertain identity never opens offers. */ }
      } catch (error) {
        if (error.message === "changed" || error.message === "rejected") {
          status.textContent = error.message === "changed" ? root.dataset.changedLabel : root.dataset.errorLabel;
          status.classList.add("error");
          retry.hidden = false;
        } else {
          let reconciled = false;
          await new Promise((resolve) => setTimeout(resolve, 750));
          try {
            const afterCart = await fetchCart();
            updateCartCount(afterCart);
            if (beforeCart && matchingQuantity(afterCart, requestedVariantId, planId) >= matchingQuantity(beforeCart, requestedVariantId, planId) + requestedQuantity) {
              status.textContent = root.dataset.addedLabel;
              reconciled = true;
            }
          } catch (cartError) { /* An uncertain request must not be retried blindly. */ }
          if (!reconciled) {
            uncertain = true;
            status.textContent = `${root.dataset.timeoutLabel} ${root.dataset.uncertainLabel}`;
            status.classList.add("error");
            cartCheck.hidden = false;
          }
        }
      } finally {
        clearTimeout(timer);
        delete form.dataset.submitting;
        add.disabled = uncertain || !selected?.available;
        add.textContent = selected?.available ? root.dataset.addLabel : root.dataset.unavailableLabel;
      }
    };
    form.addEventListener("submit", (event) => { event.preventDefault(); submit(); });
    retry.addEventListener("click", submit);
    syncVariant(false);

    const mediaIds = [...(gallery?.querySelectorAll("[data-media-id]") || [])].map((node) => node.dataset.mediaId);
    const move = (delta, focusTab = false) => {
      if (!mediaIds.length) return;
      const current = gallery.querySelector(".is-active")?.dataset.mediaId;
      const next = mediaIds[(mediaIds.indexOf(current) + delta + mediaIds.length) % mediaIds.length];
      showMedia(next);
      if (focusTab) gallery.querySelector(`[data-gallery-thumb="${CSS.escape(next)}"]`)?.focus();
    };
    gallery?.addEventListener("click", (event) => {
      const thumb = event.target.closest("[data-gallery-thumb]");
      if (thumb) showMedia(thumb.dataset.galleryThumb);
      if (event.target.closest("[data-gallery-previous]")) move(-1);
      if (event.target.closest("[data-gallery-next]")) move(1);
      const zoom = event.target.closest("[data-product-zoom]");
      if (zoom && dialog) {
        zoomTrigger = zoom;
        dialog.showModal();
        syncZoom(zoom.closest("[data-gallery-image]"));
        dialog.querySelector("[data-product-zoom-close]").focus();
      }
    });
    gallery?.addEventListener("keydown", (event) => {
      if (!event.target.matches("[data-gallery-thumb]")) return;
      const rtl = document.documentElement.dir === "rtl";
      if (event.key === "ArrowLeft") { event.preventDefault(); move(rtl ? 1 : -1, true); }
      if (event.key === "ArrowRight") { event.preventDefault(); move(rtl ? -1 : 1, true); }
      if (event.key === "Home") { event.preventDefault(); showMedia(mediaIds[0]); gallery.querySelector(`[data-gallery-thumb="${CSS.escape(mediaIds[0])}"]`)?.focus(); }
      if (event.key === "End") { event.preventDefault(); showMedia(mediaIds.at(-1)); gallery.querySelector(`[data-gallery-thumb="${CSS.escape(mediaIds.at(-1))}"]`)?.focus(); }
    });
    const swipe = (element, action) => {
      let start;
      element?.addEventListener("touchstart", (event) => {
        const touch = event.touches[0];
        start = touch && event.touches.length === 1 ? { x: touch.clientX, y: touch.clientY } : null;
      }, { passive: true });
      element?.addEventListener("touchcancel", () => { start = null; }, { passive: true });
      element?.addEventListener("touchend", (event) => {
        if (!start || event.changedTouches.length !== 1) { start = null; return; }
        const x = event.changedTouches[0].clientX - start.x;
        const y = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.25) {
          action((x > 0 ? -1 : 1) * (document.documentElement.dir === "rtl" ? -1 : 1));
        }
      }, { passive: true });
    };
    swipe(gallery?.querySelector("[data-gallery-stage]"), (delta) => {
      if (!gallery.querySelector(".is-active")?.hasAttribute("data-gallery-image")) return;
      move(delta);
    });
    const zoomMove = (delta) => {
      if (imageSlides.length < 2 || !dialog?.open) return;
      const current = gallery.querySelector(".is-active")?.dataset.mediaId;
      const index = imageSlides.findIndex((slide) => slide.dataset.mediaId === current);
      showMedia(imageSlides[(index + delta + imageSlides.length) % imageSlides.length].dataset.mediaId);
    };
    dialog?.addEventListener("click", (event) => {
      if (event.target.closest("[data-product-zoom-close]")) dialog.close();
      if (event.target.closest("[data-product-zoom-previous]")) zoomMove(-1);
      if (event.target.closest("[data-product-zoom-next]")) zoomMove(1);
    });
    dialog?.addEventListener("keydown", (event) => {
      const rtl = document.documentElement.dir === "rtl";
      if (event.key === "ArrowLeft") { event.preventDefault(); zoomMove(rtl ? 1 : -1); }
      if (event.key === "ArrowRight") { event.preventDefault(); zoomMove(rtl ? -1 : 1); }
    });
    dialog?.addEventListener("close", () => {
      const triggerSlide = zoomTrigger?.closest("[data-media-id]");
      if (triggerSlide?.hidden) {
        gallery.querySelector("[data-gallery-thumb][aria-selected=true]")?.focus();
      } else {
        zoomTrigger?.focus();
      }
    });
    swipe(dialog?.querySelector("[data-product-zoom-image]"), zoomMove);
  });
})();